export default "__VITE_ASSET__BFjEg$VJ__"